import { useMemo } from "react";
import MassFlow from "../../components/massFlow";
import { MassFlowConfig } from "../../components/massFlow/types";
import { asnMassColumns } from "../columns";
import { validateAsn } from "../validation";
import { asnsFromCsv, downloadCsvTemplate } from "./csv";
import { Asn, ASN_FIELDS, emptyAsn } from "../types";

export interface MassAsnsProps {
  asns: Asn[];
  search: string;
  onSearchChange: (value: string) => void;
  onBack: () => void;
  onSaved: () => Promise<void> | void;
}

export default function MassAsns(props: MassAsnsProps) {
  const { asns, search, onSearchChange, onBack, onSaved } = props;

  const config = useMemo<MassFlowConfig>(
    () => ({
      tableId: "asnsMassFlow",
      endpoint: "/easyFlow2.0/asn",
      entity: {
        singular: "ASN",
        plural: "ASNs",
        gender: "m",
      },
      searchPlaceholder: "Pesquisar ASNs",
      fields: ASN_FIELDS,
      emptyValues: emptyAsn,
      columns: asnMassColumns,
      validate: validateAsn,
      csv: {
        onDownloadTemplate: downloadCsvTemplate,
        parse: asnsFromCsv,
      },
    }),
    [],
  );

  return (
    <MassFlow
      config={config}
      records={asns}
      search={search}
      onSearchChange={onSearchChange}
      onBack={onBack}
      onSaved={onSaved}
    />
  );
}
